import { Box } from '@mantine/core';
import { FC } from 'react';
import { usePatient } from '@/hooks/usePatient';
import EncounterImagesList from './EncounterImagesList';

export const ImageTab: FC = () => {
  const patient = usePatient();
  return (
    <Box m="xs" p="xs" mt="lg">
      <EncounterImagesList patient={patient} />
    </Box>
  );
};
